module.exports = __webpack_public_path__ + "img/fo.c71ab350.svg";